import React, { useState, useEffect } from "react";
import { loadAndConvertImage } from "../../utils/heicConverter";

const MediaDisplay = ({ url, contentType, label, style, className = "media-content" }) => {
  const [displayUrl, setDisplayUrl] = useState(url);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!url) {
      setDisplayUrl(null);
      return;
    }

    setIsLoading(true);
    
    const convertImage = async () => {
      try {
        const converted = await loadAndConvertImage(url, contentType);
        setDisplayUrl(converted);
      } catch (error) {
        console.error('Error processing image:', error);
        setDisplayUrl(url);
      } finally {
        setIsLoading(false);
      }
    };

    convertImage();

    return () => {
      // Очищаем объектный URL если это blob
      if (displayUrl && displayUrl.startsWith('blob:')) {
        URL.revokeObjectURL(displayUrl);
      }
    };
  }, [url, contentType]);

  if (!url) {
    return (
      <div style={style}>
        <div className="no-media-placeholder"></div>
      </div>
    );
  }

  // Показываем загрузку пока конвертируется HEIC
  if (isLoading) {
    return (
      <div style={style} className={`${className} d-flex align-items-center justify-content-center`}>
        <div className="spinner-border spinner-border-sm text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (contentType && contentType.startsWith('video/')) {
    return (
      <video
        src={displayUrl || url}
        autoPlay
        muted
        loop
        className={className}
        alt={label}
        style={style}
      />
    );
  } else {
    return (
      <img
        src={displayUrl || url}
        className={className}
        alt={label}
        style={style}
        loading="lazy"
      />
    );
  }
};

export default MediaDisplay;
